export const isWordCountPercentOutsideRange = (
  maxCount: number,
  wordCount: number
) => {
  return Number((Math.abs(maxCount - wordCount) / maxCount) * 100 > 10)
}
